var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportIconBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5.83325V20.4166M17.5 20.4166L21.875 16.0416M17.5 20.4166L13.125 16.0416",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 29.1667C14.4055 29.1667 11.438 27.9375 9.2501 25.7496C7.06217 23.5617 5.83301 20.5942 5.83301 17.5M29.1663 17.5C29.1674 19.2491 28.7747 20.9759 28.0173 22.5525C27.2599 24.1291 26.1574 25.5149 24.7913 26.6073",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIconBlack);
export default __webpack_public_path__ + "static/media/ImportIconBlack.a38f67229998235ed5159205db7a3d0b.svg";
export { ForwardRef as ReactComponent };